import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import LocaleRoute from './localeRoute';
import Unknow404 from 'components/unknow404';

import Main from 'modules/mainModule/index';

const RootRouter = () => {
  return (
    <Router>
      <Route>
        <Main>
          <Switch>
            {/* <Route path='/:locale(zh-tw|en|jp|kr|th)' component={LocaleRoute} /> */}
            <Route path='/:locale(zh-tw|en)' component={LocaleRoute} />
            <Route path='*' component={Unknow404} />
          </Switch>
        </Main>
      </Route>
    </Router>
  )
}

export default RootRouter;